import React from 'react';
import { UserShape } from '../shapes';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

export default class ProfileEdit extends React.Component {

  static propTypes = {
    user: UserShape,
    onUpdateAccount: PropTypes.func
  }

  state = {
    name: this.props.user.get('name') || '',
    headline: this.props.user.get('headline') || '',
    updated: false
  }

  render() {
    if(this.state.updated) {
      return this.renderUpdated();
    } else {
      return this.renderForm();
    }
  }

  renderForm() {
    return (
      <div className='make-public-profile'>
        <h2>Edit Profile</h2>
        <form>
          <div className="form-group">
            <label htmlFor="name">Name (optional)</label>
            <input type="text" autoFocus className="input-text" id="name" value={ this.state.name } autoComplete='off' onChange={ event => this.onNameChanged(event) } placeholder="first and last"></input>
          </div>
          <div className="form-group">
            <label htmlFor="name">Headline</label>
            <input type="text" className="input-text" id="headline" value={ this.state.headline } autoComplete='off' onChange={ event => this.onHeadlineChanged(event) } placeholder="Lover of words."></input>
          </div>
          <div className="form-group">
            <Link to='/account/make_private_profile'>Hide Profile and Turn Off Following</Link>
          </div>
        </form>
        <div className='action'>
          <Link to={ `/people/${this.props.user.get('slug')}` } className='btn btn-outline-secondary'>Nevermind</Link>
          <button onClick={ this.onUpdate.bind(this) } className='btn btn-dark' data-primary-cta='true'>Update</button>
        </div>
      </div>
    );
  }

  renderUpdated() {
    return (
      <div className='row public-profile-confirmation'>
        <div className='offset-sm-2 col-sm-8'>
          <p>
            Done! We've updated your profile.
          </p>
        </div>
        <div className='offset-sm-2 col-sm-8 action'>
          <Link to={ `/people/${this.props.user.get('slug')}` } className='btn btn-dark'>View Profile</Link>
        </div>
      </div>
    )
  }

  onNameChanged(event) {
    this.setState({ name: event.target.value });
  }

  onHeadlineChanged(event) {
    this.setState({ headline: event.target.value });
  }

  onUpdate() {
    this.props.onUpdateAccount(this.state.name, this.state.headline, true);
    this.setState({ updated: true });
  }
}



// WEBPACK FOOTER //
// ./src/components/profile_edit.jsx